exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".string[data-v-17a18344] {\n  color: green;\n}\n.number[data-v-17a18344] {\n  color: darkorange;\n}\n.boolean[data-v-17a18344] {\n  color: blue;\n}\n.null[data-v-17a18344] {\n  color: magenta;\n}\n.key[data-v-17a18344] {\n  color: red;\n}\n", ""]);

